import React from "react";
import { Box } from "@mui/material";
import BackgroundWrapper from "../BackgroundWrapper";
import { useAppSelector } from "../../store";
import { HomeCancelledHero } from "./HomeCancelledHero";
import { HomeCancellationAnnouncement } from "./HomeCancellationAnnouncement";

const HomeCancelled: React.FC = () => {
  const tournoi = useAppSelector((state) => state.tournoi.tournoi);

  const tournamentLabel =
    tournoi?.label?.trim() || "Tournoi national SQY Ping";

  return (
    <BackgroundWrapper>
      <Box
        sx={{
          px: { xs: 2, sm: 3, md: 4 },
          pb: { xs: 4, sm: 5 },
          maxWidth: 1100,
          mx: "auto",
          display: "flex",
          flexDirection: "column",
          overflowX: "hidden",
        }}
      >
        <HomeCancelledHero tournamentLabel={tournamentLabel} />

        <HomeCancellationAnnouncement message={tournoi?.cancellationMessage} />
      </Box>
    </BackgroundWrapper>
  );
};

export default HomeCancelled;
